import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "py-4" }
const _hoisted_2 = { class: "otp-wrap mb-2" }
const _hoisted_3 = { class: "d-flex justify-space-between align-center mb-4" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "text-body-2 text-medium-emphasis"
}
const _hoisted_8 = {
  key: 1,
  class: "text-body-2 text-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_col, { class: "pageStyle" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_form, {
                ref: "formRef",
                modelValue: _ctx.isValid,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isValid) = $event)),
                "validate-on": "input",
                onSubmit: _withModifiers(_ctx.onSubmit, ["prevent"])
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_component_v_img, {
                      class: "mx-auto mb-10",
                      "max-width": "228",
                      src: _ctx.logo
                    }, null, 8, ["src"]),
                    _createVNode(_component_v_card, {
                      class: "mx-auto pa-12 pb-8",
                      elevation: "8",
                      "max-width": "448",
                      rounded: "lg"
                    }, {
                      default: _withCtx(() => [
                        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-subtitle-1 text-medium-emphasis mb-4" }, "Introdu codul", -1)),
                        _createElementVNode("div", _hoisted_2, [
                          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                            return _createVNode(_component_v_text_field, {
                              key: 'd' + (i - 1),
                              ref_for: true,
                              ref: 'd' + (i - 1),
                              modelValue: _ctx.digits[i - 1],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.digits[i - 1]) = $event),
                              variant: "outlined",
                              density: "compact",
                              "center-affix": "",
                              class: "otp-box",
                              rules: [_ctx.required, _ctx.oneDigit],
                              maxlength: "1",
                              inputmode: "numeric",
                              pattern: "[0-9]*",
                              onKeydown: ($event: any) => (_ctx.onKeydown($event, i - 1)),
                              onInput: ($event: any) => (_ctx.onInput($event, i - 1)),
                              onPaste: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onPaste($event)))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "rules", "onKeydown", "onInput"])
                          }), 64))
                        ]),
                        _createElementVNode("div", _hoisted_3, [
                          _cache[4] || (_cache[4] = _createElementVNode("span", { class: "text-caption text-medium-emphasis" }, "Cod din 4 cifre", -1)),
                          _createElementVNode("button", {
                            class: "text-button",
                            disabled: _ctx.resendDisabled,
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onResend && _ctx.onResend(...args))),
                            type: "button"
                          }, [
                            (_ctx.resendDisabled)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Retrimite codul (" + _toDisplayString(_ctx.resendSeconds) + "s)", 1))
                              : (_openBlock(), _createElementBlock("span", _hoisted_6, "Retrimite codul"))
                          ], 8, _hoisted_4)
                        ]),
                        _createVNode(_component_v_text_field, {
                          modelValue: _ctx.fullCode,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.fullCode) = $event)),
                          class: "d-none",
                          rules: [_ctx.required, _ctx.codeRule],
                          "hide-details": ""
                        }, null, 8, ["modelValue", "rules"]),
                        _createVNode(_component_v_btn, {
                          block: "",
                          class: "mb-8",
                          color: "blue",
                          size: "large",
                          variant: "tonal",
                          type: "submit",
                          disabled: !_ctx.isValid || _ctx.loading,
                          loading: _ctx.loading
                        }, {
                          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                            _createTextVNode(" Trimite ", -1)
                          ]))]),
                          _: 1
                        }, 8, ["disabled", "loading"]),
                        (_ctx.message)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.message), 1))
                          : _createCommentVNode("", true),
                        (_ctx.error)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.error), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              }, 8, ["modelValue", "onSubmit"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}